(function () {
  var STORAGE_KEY = 'brakefreeScreenTheme';
  var CLASS_DARK = 'screen-theme-dark';
  var THEME_TOGGLE_SEL = '.mobile-sticky-menu-circle-5-night-day__container';

  function getStored() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function syncHeroBannerCta(isDark) {
    document.querySelectorAll('.hero-banner-section a.hero-banner__button').forEach(function (el) {
      var editor = el.getAttribute('data-hero-btn-editor');
      if (isDark) {
        el.classList.add('hero-banner__button--light');
      } else {
        el.classList.toggle('hero-banner__button--light', editor === 'light');
      }
    });
  }

  function syncNightDayA11y() {
    document.querySelectorAll(THEME_TOGGLE_SEL).forEach(function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Toggle light and dark screen');
    });
  }

  function apply(theme) {
    var isDark = theme === 'dark';
    document.documentElement.classList.toggle(CLASS_DARK, isDark);
    document.querySelectorAll(THEME_TOGGLE_SEL).forEach(function (btn) {
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    });
    syncHeroBannerCta(isDark);
  }

  function setTheme(theme) {
    apply(theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
  }

  function toggle() {
    var next = document.documentElement.classList.contains(CLASS_DARK) ? 'light' : 'dark';
    setTheme(next);
  }

  window.brakefreeToggleScreenTheme = toggle;
  window.brakefreeSetScreenTheme = setTheme;

  function bindGlobalHandlers() {
    if (window.__brakefreeScreenThemeHandlersBound) return;
    window.__brakefreeScreenThemeHandlersBound = true;

    document.addEventListener('shopify:section:load', function () {
      syncNightDayA11y();
      var s = getStored();
      if (s === 'dark' || s === 'light') apply(s);
    });

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target && e.target.closest && e.target.closest(THEME_TOGGLE_SEL);
        if (!t) return;
        e.preventDefault();
        e.stopPropagation();
        toggle();
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var active = document.activeElement;
        var t = active && active.closest && active.closest(THEME_TOGGLE_SEL);
        if (!t) return;
        e.preventDefault();
        toggle();
      },
      true
    );
  }

  function init() {
    var stored = getStored();
    if (stored === 'dark' || stored === 'light') {
      apply(stored);
    } else {
      apply('light');
    }

    syncNightDayA11y();
    bindGlobalHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
